import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { GET_MODALITY_TYPES } from '../../constants/ActionTypes';
import { fetchModalityTypesAPI } from '../../services/modality-service';
import { getModalityTypesSuccess } from '../actions/ModalityTypes';


function* fetchModalityTypes({ }) {
    try {
        const response = yield call(fetchModalityTypesAPI);
        if (response.success) {
            yield put(getModalityTypesSuccess(response.data));
        }
    }
    catch (error) {
        // yield put(show(error));
    }
}


function* getModalityTypes() {
    yield takeLatest(GET_MODALITY_TYPES, fetchModalityTypes);
}

export default function* rootSaga() {
    yield all([getModalityTypes()]);
}